type NotApplicableValue = null | 1 | 0

export const mapNotApplicableNullable = (
  isApplicable: boolean | null | undefined
): NotApplicableValue | undefined => {
  if (isApplicable === null) {
    return null
  }

  if (isApplicable === undefined) {
    return undefined
  }

  return isApplicable ? 0 : 1
}
